/**
 * ЭТАП 2 — ЧИСТЫЙ билдер каталожного меню, извлечён 1:1 из
 * CatalogStore.getCatalogMenu (.then-маппинг). Используется:
 *  - стором (клиент, как раньше);
 *  - CatalogCategory как SSR/пре-стор фолбэк: данные обоих запросов
 *    префетчатся на сервере (ssrPrefetch), меню рендерится в SSR-HTML.
 */
import {
  CatalogMenuItemType,
  type CatalogMenuItem
} from './CatalogStore.type';
import { barMenuCatalogIcon } from '@images';

// Ответы mobileMenuTree / barMenuCategories (типы через any — в сторе они
// приходили из ensureQueryData тоже без явной аннотации)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyRes = any;

export const buildCatalogMenu = (
  mainRes: AnyRes,
  barRes: AnyRes,
  {
    isDesktop,
    withBarMenu
  }: {
    isDesktop: boolean;
    withBarMenu?: boolean;
  }
): CatalogMenuItem[] => {
  const barMenuItem: CatalogMenuItem = {
    id: 'bar-menu',
    identify: 'bar-menu',
    type: CatalogMenuItemType.Product,
    icon: barMenuCatalogIcon.x3,
    title: 'Меню устричного бара',
    isBarMenu: true,
    isActive: false,
    url: '/catalog/bar',
    childrenItems: barRes?.getMobileMenuTree
      ?.filter(item => item.is_not_for_sale !== 1)
      ?.map(item => ({
        url: `/catalog/${item.identify}`,
        title: item.title || 'Категория',
        isActive: false,
        icon: item.fileItem?.cacheItem?.[0]?.filePath ?? '',
        bg_color: item.bg_color,
        badge_text: item.badge_text
      })),
    isHidden: !withBarMenu
  };

  const menu: CatalogMenuItem[] = mainRes?.getMobileMenuTree?.map(
    item => ({
      id: item.id,
      type: CatalogMenuItemType.Product,
      identify: item.identify ?? item.id,
      rubticProductsCount: item.rubticProductsCount,
      title: item.title,
      icon: item.fileItem?.cacheItem?.[0]?.filePath ?? '',
      isBarMenu: false,
      childrenItems: item.childrenItems?.length
        ? item.childrenItems.map(subMenu => {
            let url = '';
            if (
              subMenu?.identify === 'newbee' ||
              subMenu?.identify === 'delikateska' ||
              subMenu?.identify === 'promo'
            ) {
              url =
                '/catalog/' +
                (item?.identify ?? '') +
                `/r/${subMenu?.identify}/yes`;
            } else {
              url = '/catalog/' + `${subMenu?.identify ?? ''}`;
            }
            return { ...subMenu, url, isActive: false };
          })
        : [],
      rubricGroup: item.rubricGroup?.length
        ? item.rubricGroup.map(group => ({
            ...group,
            url: `/catalog/${item?.identify ?? ''}/r/group/${
              group?.identify ?? ''
            }`
          }))
        : null,
      rubricGroupTitle: item.rubricGroupTitle,
      isActive: false,
      url: `/catalog/${item.identify ?? ''}`
    })
  );

  let catalogMenu: CatalogMenuItem[];
  if (isDesktop) {
    // const serviceItem: CatalogMenuItem = {
    //   icon: 'https://storage.delikateska.ru/6/c/001c6e91-eab4-4d54-b8b2-a3ac0b323f6e.png',
    //   id: 'services',
    //   identify: 'services',
    //   isBarMenu: false,
    //   title: 'Услуги',
    //   type: CatalogMenuItemType.Service,
    //   isActive: false,
    //   url: '/catalog/services',
    //   childrenItems: [
    //     {
    //       id: 'knives',
    //       identify: '/#/service/8',
    //       title: 'Заточка ножей',
    //       url: '/#/service/8',
    //       isActive: false
    //     },
    //     {
    //       id: 'chef',
    //       identify: '/faq',
    //       title: 'Спроси шеф-повара',
    //       url: '/faq',
    //       isActive: false
    //     }
    //   ]
    // };
    const chiefItem: CatalogMenuItem = {
      icon: 'https://storage.delikateska.ru/4/d/6b782083-4baa-4d70-93b4-cbc0c77e3cc3.png',
      id: 'chief',
      isBarMenu: false,
      type: CatalogMenuItemType.Product,
      identify: 'ot-shefa',
      url: '/catalog/ot-shefa',
      title: 'От Шефа',
      childrenItems: mainRes?.getChefCatalogRubrics.rubricMenuTree?.length
        ? mainRes?.getChefCatalogRubrics.rubricMenuTree?.map(item => ({
            ...item,
            url: `/catalog/${item.identify ?? ''}`,
            isActive: false
          }))
        : null,
      isActive: false
    };
    const ind = menu.findIndex(item => item.id === '308');
    catalogMenu = [
      barMenuItem,
      ...menu.slice(0, ind),
      chiefItem,
      ...menu.slice(ind, menu.length)
      // serviceItem
    ];
  } else {
    catalogMenu = [barMenuItem, ...menu];
  }
  catalogMenu = catalogMenu.filter(item => !item.isHidden);
  return catalogMenu;
};
